import { MutationTree } from "vuex/types";
import { FileUploadState } from "./types";
import Vue from "vue";

/**
 * Mutations for the File Storage module.
 * Handles synchronous state updates for storage configuration.
 */
const mutations: MutationTree<FileUploadState> = {
  /**
   * Sets the storage backend type.
   *
   * @param {FileUploadState} state - Module state
   * @param {string} storageType - Storage type ('azure' or 'ceph')
   */
  SET_STORAGE_TYPE: (state, storageType: string) => {
    Vue.set(state, "storageType", storageType);
  },
};

export default mutations;
